import { IBasicCancelProceedPopupProps } from '../../../../components/popups/BasicCancelProceedPopup/BasicCancelProceedPopup.types';
import BasicCancelProceedPopup from '../../../../components/popups/BasicCancelProceedPopup/BasicCancelProceedPopup';

const ChangePrimaryLinePopup = (props: IBasicCancelProceedPopupProps) => {
    const { showPopup, onDialogClose } = props;

    return (
        <BasicCancelProceedPopup
            showPopup={showPopup}
            popupHeader={'Are You Sure?'}
            popupText={
                'Only one line can be set as the Account Holder line. Your other choice will be removed.'
            }
            onDialogClose={onDialogClose}
        />
    );
};

export default ChangePrimaryLinePopup;
